import { SortableItemContainerComponent } from "@/Common/Components/Collections/SortableItemContainer";
import { MedicalItemRiskFactor } from "@/Patient/Models/MedicalSummary/MedicalItemRiskFactor";

class SortableContainerForRiskFactors extends SortableItemContainerComponent<MedicalItemRiskFactor> { }

export { SortableContainerForRiskFactors };
